import './ShareModal.scss';

import { QRCodeCanvas } from "qrcode.react";
import { useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { api } from '../../../utils/api';
import { useArtistContext } from '../ArtistPageContext';

export default function ShareModal({ show, handleClose }) {
  const { artist, setArtist } = useArtistContext();
  const qrRef = useRef();
  const debounceRef = useRef(null);
  const [isPublic, setIsPublic] = useState(artist.public);

  const handlePublicToggle = (e) => {
    const value = e.target.checked;
    setIsPublic(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      const { data: updatedArtist } = await api.put(`/profiles/${artist.id}`, { public: value });
      setArtist(updatedArtist);
    }, 500);
  };

  const shareLink = `${process.env.REACT_APP_WEBSITE_URL}/a/${artist.display_name}`;

  const downloadQR = () => {
    const canvas = qrRef.current;
    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const link = document.createElement("a");
    link.href = pngUrl;
    link.download = `${artist.display_name}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal className="__share-modal" show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Share your Artist Profile</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body">
        <Form.Check
          type="switch"
          id="public-toggle"
          label={ isPublic ? "Let others discover my profile" : "My profile is hidden from search" }
          checked={ isPublic }
          onChange={ handlePublicToggle }
          className="align-self-start"
        />

        { shareLink && (
          <div className="mb-4">
            <QRCodeCanvas ref={ qrRef } value={ shareLink } size={ 200 } />
          </div>
        ) }

        <Button className="ppy-btn ppy-btn-primary mb-3" onClick={ downloadQR }>
          Download QR Code
        </Button>

        <Form.Control
          value={ shareLink }
          readOnly
          onClick={ (e) => e.target.select() }
        />
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleClose }>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
